import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ToothNumberInput = ({ selectedTeeth = [], onChange, error }) => {
  const [inputValue, setInputValue] = useState('');
  const [inputError, setInputError] = useState('');

  const validateFDI = (number) => {
    const num = parseInt(number);
    if (isNaN(num)) return false;
    
    const quadrant = Math.floor(num / 10);
    const tooth = num % 10;
    
    return quadrant >= 1 && quadrant <= 4 && tooth >= 1 && tooth <= 8;
  };

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setInputValue(value);
    setInputError('');
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ',') {
      e?.preventDefault();
      addToothNumber();
    }
  };

  const addToothNumber = () => {
    const trimmed = inputValue?.trim();
    if (!trimmed) return;

    if (!validateFDI(trimmed)) {
      setInputError('Numéro FDI invalide (ex: 11, 21, 36)');
      return;
    }

    if (selectedTeeth?.includes(trimmed)) {
      setInputError('Dent déjà ajoutée');
      return;
    }

    onChange([...selectedTeeth, trimmed]);
    setInputValue('');
    setInputError('');
  };

  const removeToothNumber = (number) => {
    onChange(selectedTeeth?.filter(n => n !== number));
  };

  return (
    <div className="bg-[#1A1F26] border border-white/10 rounded-xl p-5">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-white mb-1">
          Dent(s) concernée(s) <span className="text-red-400">*</span>
        </h2>
        <p className="text-xs text-gray-400">
          Format FDI uniquement (11, 21, 25, 36, etc.)
        </p>
      </div>
      
      <div className="flex gap-2 mb-4">
        <div className="flex-1">
          <Input
            label="Ajouter une dent"
            type="text"
            placeholder="Ex: 11, 21, 36"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            error={inputError || error}
          />
        </div>
        <button
          type="button"
          onClick={addToothNumber}
          disabled={!inputValue?.trim()}
          className="mt-7 px-4 h-11 bg-blue-500 hover:bg-blue-600 disabled:bg-blue-500/30 disabled:cursor-not-allowed text-white rounded-xl transition-all flex items-center gap-2 text-sm font-medium"
        >
          <Icon name="Plus" size={18} />
          <span className="hidden sm:inline">Ajouter</span>
        </button>
      </div>
      
      {selectedTeeth?.length > 0 && (
        <div className="pt-4 border-t border-white/10">
          <div className="text-xs text-gray-400 mb-3">
            Dents sélectionnées ({selectedTeeth?.length}) :
          </div>
          <div className="flex flex-wrap gap-2">
            {selectedTeeth?.map((number) => (
              <div
                key={number}
                className="inline-flex items-center gap-2 px-3 py-2 bg-blue-500/10 border border-blue-500/30 rounded-lg hover:bg-blue-500/20 transition-all"
              >
                <span className="text-sm font-semibold text-blue-400">{number}</span>
                <button
                  type="button"
                  onClick={() => removeToothNumber(number)}
                  className="p-0.5 hover:bg-blue-500/30 rounded transition-all"
                  aria-label={`Retirer la dent ${number}`}
                >
                  <Icon name="X" size={14} className="text-blue-400" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ToothNumberInput;